<template>
  <template
      v-if="show">
    <div class="font-weight flex between">
      <span>
        {{ option.name }}
        <span class="pos-r" v-if="option.nameTip" style="left: -6px; top: 2px">
                <el-tooltip effect="dark" :content="option.nameTip" placement="top">
                  <el-icon class="fs-12 cursor ml-2">
                    <QuestionFilled></QuestionFilled>
                  </el-icon>
                </el-tooltip>
        </span>
      </span>
      <svg-icon
          v-if="option.showFx"
          @click="$emit('indexFx',option)"
          color="#878f95"
          class="text m mr-4"
          icon-class="fx"
      />
    </div>
    <div
        class="cs-drop-area flex flex-column vcenter"
        :class="highLightShow && 'cs-highlight'"
        @dragover="
                (e) => {
                $emit('indexDragover',e,option.code)
              }
              "
        @drop="
                (e) => {
     $emit('indexDrop',option,option.code)
    }
    "
    >
      <div
          v-if="loopVariable"
          v-for="(item, index) in loopVariable"
          class="cs-drag-item pbg left flex between wh100"
          :key="index"
      >
              <span data-color="#000"
                    :data-index="index" :data-dtype="option.dropType || option.code"
                    v-swapListByDrag="loopVariable"
                    class="color b ellipse-name-left" :title="item.aliasName || item.name">
                <svg-icon
                    class="text m rei"
                    color="#fff"
                    :icon-class="getIcon(item.fieldType || item.type)"
                />
                {{calcName(item)}}
              </span>
        <div class="pointer">
          <svg-icon
              v-if="option.showEdit"
              title="编辑"
              class="text m mr-2"
              @click="$emit('indexEdit',item, index,option)"
              color="#fff"
              icon-class="a_edit"
          />
          <svg-icon
              title="删除"
              class="text m"
              @click="isLink ? $emit('deleteLink',item,index): loopVariable.splice(index, 1)"
              color="#fff"
              icon-class="a_del"
          />
          <BindModel
              v-if="option.showBindModel"
              showPageParam
              show-loop
              :linkData="linkData"
              white
              v-model:bindParam="item.bindParam"
          ></BindModel>
        </div>
      </div>
      <div class="drop-tip fs-12 tac wp100 color g">将字段拖至此处</div>
    </div>
  </template>
</template>
<script setup>
import {Edit, QuestionFilled} from "@element-plus/icons-vue";
import {
  MODEL_COLUMN_TYPE,
  METRIC_TYPE,
  INDEX_DROP_TYPE,
  SPREAD_SHEET_TYPE,
  INDEX_TYPE,
  LOOP_KEY_MAP, DATA_SOURCE_TYPE
} from "@/option/common/dict.js";
import {vSwapListByDrag} from "@/option/common/directives";
import BindModel from "./bindModel.vue";
import {computed} from "vue";

let props = defineProps({
  option: {},
  dcOption: {},
  dcProp: {},
  dragType: {},
  dragData: {},
  currentLink: {},
  linkData: {
    default() {
      return {};
    },
  },
})
const isLink = computed(() => {
  return props.option.code === INDEX_DROP_TYPE.LINK;
})

function getIcon(type) {
  switch (type) {
    case MODEL_COLUMN_TYPE.date:
      return "date";
    case MODEL_COLUMN_TYPE.number:
      return "123";
    case METRIC_TYPE.CUS:
      return "fx";
    default:
      return "abc";
  }
}

/**
 * 每种配置对应的拖拽类型 如列 可拖 指标 和 维度
 *
 */
const HIGHLIGHT_MAP = {
  [INDEX_DROP_TYPE.ROW]: [INDEX_TYPE.DIMENSION],
  [INDEX_DROP_TYPE.COLUMNS]: [INDEX_TYPE.DIMENSION, INDEX_TYPE.METRIC],
  [INDEX_DROP_TYPE.DIMENSION]: [INDEX_TYPE.DIMENSION],
  [INDEX_DROP_TYPE.GROUP]: [INDEX_TYPE.DIMENSION],
  [INDEX_DROP_TYPE.METRICS]: [INDEX_TYPE.METRIC],
  [INDEX_DROP_TYPE.REFERENCE]: [INDEX_TYPE.METRIC],
  [INDEX_DROP_TYPE.ASSIST]: [INDEX_TYPE.METRIC],
  [INDEX_DROP_TYPE.TOTAL]: [INDEX_TYPE.METRIC],
  [INDEX_DROP_TYPE.LABEL_IDENT]: [INDEX_TYPE.FILTER],
  [INDEX_DROP_TYPE.METRIC_R]: [INDEX_TYPE.METRIC],
  [INDEX_DROP_TYPE.METRIC_L]: [INDEX_TYPE.METRIC],
  [INDEX_DROP_TYPE.LINK]: [INDEX_TYPE.DIMENSION, INDEX_TYPE.METRIC],
  [INDEX_DROP_TYPE.FILTER]: [INDEX_TYPE.FILTER]
}
const loopVariable = computed(() => {
  if (isLink.value) {
    let list = []
    for (const listKey in props.currentLink) {
      let el = props.currentLink[listKey]
      if (typeof el !== 'string') {
        list.push(el)
      }
    }
    return list
  }
  return props.dcProp[LOOP_KEY_MAP[props.option.code]]
})
const highLightShow = computed(() => {
  return HIGHLIGHT_MAP[props.option.code].includes(props.dragType)
})
const show = computed(() => {
  if (props.option.code === INDEX_DROP_TYPE.ROW) {
    return props.dcOption.spreadSheetType === SPREAD_SHEET_TYPE.BASIC
  }
  if (props.option.code === INDEX_DROP_TYPE.METRICS) {
    return props.dcOption.spreadSheetType !== SPREAD_SHEET_TYPE.DETAIL
  }
  // 拖拽过滤条件只在数据分析下展示
  if (props.dcProp.dataSourceType !== DATA_SOURCE_TYPE.BIZ && props.option.code === INDEX_TYPE.FILTER) {
    return false
  }
  return 'show' in props.option ? props.option.show : true;
})

const calcName = (item) => {
  // 处理公式指标名称显示,调整为别名 + 原始名称
  if (item?.type && item?.type === 'cus' && item?.set?.indexAlias) {
    return `${item.set?.indexAlias}(${item.fieldName})`
  }
  return (item.aliasName || item.name || item)
}

</script>


<style scoped lang="scss">
@import "@/styles/variables";

.cs-drop-area {
  margin: 10px 0;
  margin-right: 10px;
  min-height: 50px;
  background: $mainbgColor;
  padding: 4px;
  border-radius: 6px;
  border: 1px solid transparent;
  justify-content: flex-end;
  box-sizing: border-box;

  &.cs-highlight {
    background: rgba($primaryColor, 0.3);
    border: 1px dashed $primaryColor;

    .drop-tip {
      color: $primaryColor;
      opacity: 1;
    }
  }
}

.cs-drag-item {
  padding: 6px 4px;
  border-radius: 4px;
  margin-bottom: 4px;

  &.left {
    padding: 8px 4px;

    .pointer {
      svg {
        font-size: 14px;
      }
    }
  }

  &.bg {
    background: $mainbgColor;
  }

  &.pbg {
    background: #008aff;
  }
}

.drop-tip {
  opacity: 0.6;
}

.ellipse-name-left {
  max-width: 95px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  .rei {
    font-size: 12px;
  }
}
</style>